export function addAbsolutePosition(hit, index) {
  return {
    ...hit,
    __position: index + 1
  };
}